import { isHqPath } from './hq';
import { DARK_MODE_BG, type ColorMode } from '../routes/_app+/_layout/helpers/color-mode';

// Content stays light for legacy shell backgrounds. Only an explicit dark selection opts HQ in.
export function resolveHqColorMode(background: string | null | undefined): ColorMode {
  return background?.replace('#', '').toLowerCase() === DARK_MODE_BG.replace('#', '').toLowerCase() ? 'dark' : 'light';
}

// The active HQ page and its surrounding shell share one effective selection.
export function resolveSharedColorMode({ shellMode = 'light', hqMode }: { shellMode?: ColorMode; hqMode?: ColorMode }): ColorMode {
  return hqMode ?? shellMode;
}

/** HQ subroutes use the same persisted preference, including Organizations. */
export function hqModeForPath(pathname: string, mode: ColorMode | undefined): ColorMode | undefined {
  return isHqPath(pathname) ? mode : undefined;
}
